import React from "react";

export const About = (props) => {
  return (
    <div id="about" className="custom-bg-col-div-2">
      <div className="container">
        <div className="row sub-section-title">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>

          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>

            </div>
          </div>
        </div>
        <div  className="col-xs-12 col-md-6 ">
          {" "}
          <img src="img/about2.jpg" className="img-responsive" alt="" />{" "}
        </div>

        <div className="row sub-section-title">
            <h2>What we do</h2>
        </div>



        <div className="sub-section-title">
          <p>
            As everyone knows, the demand for nurses and nursing education is
            high in the United States, United Kingdom and Canada. ONE is a
            liaison company aimed at helping those intending to migrate to these
            countries get quality nursing education. We do this by partnering
            with renowned and accredited schools of nursing across the African
            continent. It is an accelerated program that lasts through a period
            of 18 months with comprehensive curriculum that encompasses broad
            knowledge of nursing science, comprising of coursework and clinical
            education. Graduates will earn a B.S. Nursing degree and can
            challenge the NCLEX exams upon arrival in the United States or
            Canada or the NMC exams in the United Kingdom.
          </p>
        </div>
      </div>
    </div>
  );
};
